import { ColumnFiltersState } from '@tanstack/react-table';
import { toSnakeCase } from './SnakeCase';

export const formatFilter = (filterState: ColumnFiltersState) => {
  return filterState.map((s) => `${toSnakeCase(s.id)}:${s.value}`).join(';');
};
